<template>
  <div class="upload-pic_list">
    <el-upload ref="upload"
               :class="[{hide:(isLimit || isDisabled)}, {del: (!delet)}]"
               :action="httpBaseURL + uploadPath"
               :data="uploadData"
               :limit="limit ? limit : null"
               list-type="picture-card"
               :file-list="pictureList"
               :on-success="(res, file, fileList) => handleAvatarSuccess(res, file, fileList)"
               :before-upload="beforeAvatarUpload"
               :on-preview="handlePictureCardPreview"
               :on-remove="handleRemove">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible"
               append-to-body
               width="60%"
               class="dialog-demo">
      <img :src="dialogImageUrl"
           alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'uploadimage',
  // props: ['fileIds', 'pictureList', 'limit', 'isDisabled', 'delet'],
  props: {
    fileIds: {},
    pictureList: {},
    limit: {},
    isDisabled: {},
    delet: {},
    fileSize: {
      default: 4
    }
  },
  data () {
    return {
      uploadData: {
        TOKEN_KEY: localStorage.getItem('token')
      },
      dialogImageUrl: '',
      dialogVisible: false,
      isLimit: false
    }
  },
  components: {
  },
  computed: {
    httpBaseURL () {
      return this.$global.httpBaseURL
    },
    uploadPath () {
      return this.$global.uploadPath
    },
    fileList () {
      return this.$refs.upload.uploadFiles
    }
  },
  watch: {
    pictureList: {
      deep: true,
      handler (val) {
        if (val.length >= this.limit) {
          this.isLimit = true
        } else {
          this.isLimit = false
        }
      }
    }
  },
  mounted () {
    if (this.pictureList.length >= this.limit) {
      this.isLimit = true
    } else {
      this.isLimit = false
    }
  },
  methods: {
    /*
    * 图片上传
    * */
    handleAvatarSuccess (res, file, fileList) {
      if (res.code === 200) {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        })
        this.fileIds.push(res.obj.toString())
      }

      if (this.limit) {
        if (fileList.length >= this.limit) {
          this.isLimit = true
        } else {
          this.isLimit = false
        }
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt4M = file.size / 1024 / 1024 < this.fileSize
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG、PNG或GIF 格式!')
      }
      if (!isLt4M) {
        this.$message.error('上传图片大小不能超过 ' + this.fileSize + 'M')
      }
      return isJPG && isLt4M
    },
    handleRemove (file, fileList) {
      // let arr = []
      if (file.response || file.id) {
        let id = file.response ? file.response.obj.toString() : file.id.toString()
        let index = this.fileIds.indexOf(id)
        if (index > -1) {
          this.fileIds.splice(index, 1)
        }
      }
      if (this.limit) {
        if (fileList.length >= this.limit) {
          this.isLimit = true
        } else {
          this.isLimit = false
        }
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.dialog-demo >>> .el-dialog__body {
  height: 72vh !important;
  overflow: scroll !important;
}
.dialog-demo >>> .el-dialog__body img {
  width: 100%;
  display: block;
  margin: 0 auto;
  max-height: 72vh;
  object-fit: contain;
}
.upload-pic_list >>> .el-upload-list__item-thumbnail {
  object-fit: cover;
}
.del >>> .el-upload-list__item-delete {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/uploadImage.vue